import Translation from 'components/Translation'
import { useAppContext } from 'context/AppContext'
import { useAppErrorApiContext } from 'context/AppErrorContext'
import { useAuth } from 'context/AuthContext'
import { classNames } from 'utils/dom-helpers'
import { deleteApiRequest } from 'utils/fetch-helper'
import { DeleteCardProps } from './types'

function DeleteCard({ card, onDelete, onCancel }: DeleteCardProps) {
    const { setGlobalError } = useAppErrorApiContext()
    const { setGlobalLoading } = useAppContext()
    const ctx = useAuth()
    const { close: closeModal } = ctx.CreditCardModal

    const handleOnDelete = async () => {
        setGlobalLoading(true)

        let api = await deleteApiRequest(
            `/v1/chargebee/payment-sources/${card?.id}`
        )

        if (api && api.ok) {
            onDelete()
            closeModal()
        } else {
            setGlobalError(api)
        }

        setGlobalLoading(false)
    }
    return (
        <div
            className={classNames(
                'bg-white rounded-2xl shadow-2xl p-8 m-auto w-5/12'
            )}
        >
            <div className="flex justify-center p-4">
                <i className="feather-alert-triangle bg-red-600 text-white text-lg rounded-full px-2 py-1"></i>
            </div>
            <div className="text-center circular inline-block self-center text-3xl text-primary-dark mx-auto mb-5">
                <div>
                    <Translation content_key="accounts.delete_card" />
                </div>
            </div>
            <div className="flex justify-center mb-4">
                <div className="bg-red-200/50 px-3 py-1 font-bold rounded-full items-center flex m-auto justify-center text-xs uppercase">
                    {card?.brand} **** {card?.last4}
                </div>
            </div>

            <div className="flex justify-end gap-3 w-full">
                <button
                    className={classNames(
                        'group text-center w-1/2',
                        'py-4 mt-6 px-3 border border-gray-300',
                        'focus:outline-none text-md rounded-md'
                    )}
                    onClick={() => {
                        onCancel()
                        closeModal()
                    }}
                >
                    <Translation content_key="cancel" />
                </button>
                <button
                    type="submit"
                    className={classNames(
                        'group w-1/2 relative flex justify-center',
                        'py-4 mt-6 px-3 border border-transparent',
                        'text-md rounded-md text-white',
                        'focus:outline-none',
                        'bg-primary hover:bg-primary-dark focus:ring-2 focus:ring-offset-2 focus:ring-primary-light',
                        'bg-primary hover:bg-primary-dark focus:ring-2 focus:ring-offset-2 focus:ring-primary-light'
                    )}
                    onClick={handleOnDelete}
                >
                    <Translation content_key="delete" />
                </button>
            </div>
        </div>
    )
}
export default DeleteCard
